// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__zcz3b","row":"Dashboard_row__RwrR4","mapContainer":"Dashboard_mapContainer__hJURT","mapResponsive":"Dashboard_mapResponsive__63Sa3"};